import { StringKeyDictionary } from "../../commonInterfaces";
import { Config } from "../../core/config/config";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { ConversationHistory } from "../../ticket/conversationHistory";
import React from "react";

const translations_reports = {
    get noRights() {
        return __internal_translations["WebSMS.UserSettings.GroupRights.0"];
    },
    get noEntries() {
        return __internal_translations["Standard.Msg.KeineErgebnisse"];
    },
    get openInNewTab() {
        return __internal_translations["WebSMS.Common.OpenInNewTab"];
    },
    get technicalApproval() {
        return __internal_translations["Field.Beleg.freigabe"];
    },
    get commercialApproval() {
        return __internal_translations["Field.Beleg.abrmon"];
    },
    get unfollow() {
        return __internal_translations["WebSMS.Events.Unfollow"];
    }
};

class EmbedTicketText extends React.Component<{ ticket: number }, any>{
    async componentDidMount() {
        const url = `${Config.baseUrl}Procedure/Get?id=${this.props.ticket}&readonly=true`;
        const response = await fetch(url);
        if (!response.ok) {
            //throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        this.setState({ data: data });
    }

    render() {
        //debugger;
        if (this.state?.data) {
            const url = `${Config.baseUrl}Procedure/Get?id=${this.props.ticket}&readonly=true`;
            let conversation = [];
            conversation = conversation.concat(this.state.data.Data.ProblemHistory);
            conversation = conversation.concat(this.state.data.Data.AnnotationHistory);
            conversation = conversation.concat(this.state.data.Data.SolutionHistory);
            const props: any = {
                handleEval: () => { },
                entity: {},
                comments: conversation,
                events: this.state.data.Data.Events,
                inputboxPosition: "top",
                noScrollbars: true,
                context: { translations: {} },
                field: {
                    "props": {
                        "noScrollbars": false,
                        "inputboxPosition": "top"
                    }
                }
            };
            return <div className="user_ticket_vorschau_frame" style={{ height: "100%", overflow: "auto" }}>{React.createElement(ConversationHistory, props)}</div>
        } else {
            return null;
        }
    }
}

class NoEntries extends React.Component<any, any>{
    render() {
        return <div className="material-card-container-user">
            <div style={{ textAlign: "center", color: "#000000", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#FFFFFF", opacity: "0.5" }}>
                <i className="fal fa-empty-set" style={{ fontSize: "5em", marginBottom: "10px" }}></i>
                <div style={{ fontFamily: "Roboto" }}>{translations_reports.noEntries}</div>
            </div>
        </div>
    }
}

class NoEntriesVorschau extends React.Component<any, any>{
    render() {
        return <div className="user_ticket_vorschau">
            <div style={{ width: "100%", textAlign: "center", color: "#000000", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#FFFFFF", opacity: "0.5" }}>
                <i className="fal fa-empty-set" style={{ fontSize: "5em", marginBottom: "10px" }}></i>
                <div style={{ fontFamily: "Roboto" }}>{translations_reports.noEntries}</div>
            </div>
        </div>
    }
}

interface rowData { 

    INNOSOFTUSER: string;
    ISGUID: string;
    OBSERVEDOBJECTGUID: string;
    OBSERVEDOBJECTTYPE: string;

    isSelected?: boolean;
    onclick: any;
    ENTRY_DOC_ISGUID: string;
    ENTRY_LINK: string;

    VERANTWORTLICHER: string;
    PROBLEMNR: number;
    KOMMENTAR: string;
    ADRNAME: string;
    TICKETTYP: string;
    TICKETSTATUS: string;
    ENDZEIT: string;

    reloadStatistics: () => void;
}


class Row extends React.Component<rowData, any>{
    openLink = () => {
        if (this.props.ENTRY_LINK && (this.props.ENTRY_LINK != "")) window.open(Config.baseUrl + this.props.ENTRY_LINK, "_blank"); //Funktion zum öffnen des gefolgten Objektes
    }

    unfollow = async () => { //Funktion für das Augen Symbol um den Objekten  nicht mehr zu folgen
        const data: StringKeyDictionary<string> = {
            objectGuid: this.props.OBSERVEDOBJECTGUID,
            objectType: this.props.OBSERVEDOBJECTTYPE
        };
        await HTTPService.get<JsonResultClass>("Event/Unfollow?", data);
        this.props.reloadStatistics();
    }

    stopPropagation = (e) => {
        e.stopPropagation();
    }


    render() {

        return <div style={{ borderLeft: this.props.isSelected ? "5px solid #00796B" : "5px solid #ffffff", backgroundColor: "#ffffff", borderBottom: "1px solid #cccccc" }} className="material-card-rep-user material-card-rep-user-clickable" onClick={() => this.props.onclick(this.props.ISGUID)}>

            <div className="grid-item1" style={{ gridArea: "ButtonOpen" }} onClick={this.openLink}>
                <span className="external-Reports-user buttonIcon" style={{ height: "30px", width: "30px" }}>
                    <i style={{ fontSize: "20px", fontWeight: 400 }} className="far fa-external-link" title={translations_reports.openInNewTab}></i>
                </span>
            </div>
            <div className="grid-item4" style={{ gridArea: "Verantwortlich", fontFamily: "Roboto", display: "flex", alignItems: "center" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px", color: "black", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }} title={this.props.VERANTWORTLICHER.length > 15 ? this.props.VERANTWORTLICHER : null }>
                    {this.props.VERANTWORTLICHER}
                </span>
            </div>
            <div className="grid-item4" style={{ gridArea: "Ticketnummer", fontFamily: "Roboto", display: "flex", alignItems: "center" }}>
                <span style={{ fontSize: "15px", color: "black" }}>
                    {this.props.PROBLEMNR}
                </span>
            </div>
            <div className="grid-item5" style={{ gridArea: "Kommentar", fontFamily: "Roboto", alignItems: "center" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px", color: "black", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }} title={this.props.KOMMENTAR.length > 15 ? this.props.KOMMENTAR : null }>
                    {this.props.KOMMENTAR}
                </span>
            </div>
            <div className="grid-item5" style={{ gridArea: "Adressname", fontFamily: "Roboto", alignItems: "center" }}>
                <span style={{ fontSize: "15px", color: "black", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }} title={this.props.ADRNAME.length > 15 ? this.props.ADRNAME : null }>
                    {this.props.ADRNAME}
                </span>
            </div>
            <div className="grid-item6" style={{ gridArea: "Tickettyp", fontFamily: "Roboto", alignItems: "center" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px", color: "black" }}>
                    {this.props.TICKETTYP}
                </span>
            </div>
            <div className="grid-item6" style={{ gridArea: "Ticketstatus", fontFamily: "Roboto", alignItems: "center" }}>
                <span style={{ fontSize: "15px", color: "black" }}>
                    {this.props.TICKETSTATUS}
                </span>
            </div>
            <div className="grid-item7" style={{ gridArea: "Termin", fontFamily: "Roboto", alignItems: "center" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px", color: "black" }}>
                    {kendo.toString(kendo.parseDate(this.props.ENDZEIT), 'd')}
                </span>
            </div>
            <div className="grid-item1" style={{ gridArea: "Entfolgen" }} onClick={this.unfollow}>
                <span className="external-Reports-user buttonIcon" style={{ height: "30px", width: "30px" }}>
                    <i style={{ fontSize: "20px", fontWeight: 400 }} className="far fa-eye-slash" title={translations_reports.unfollow}></i>
                </span>
            </div>
        </div>
    }
}





export class CompMain_Favorites_Ticket extends React.Component<any, { activeIndex: number, ISGUID?: string, docGuid?: string, hasDocs: boolean, ticket?: number }>{
    constructor(props, state) {
        super(props, state);
        this.state = { activeIndex: 0, ISGUID: null, hasDocs: false, ticket: null };
        document.addEventListener("visibilitychange", () => { this.props.api.reloadStatistic() })
    }

    refreshStatistic = () => {
        window["DelphiInterop"].statisticWidgets[this.props.context.STATISTIC_WIDGET_ID].api.reload();
    }

    handlePageChanged = (pageIndex) => {
        this.setState({ activeIndex: pageIndex });
    }

    handleGiveTechnicalApproval = (belegnr: string, apiID: string) => { //7ea6e352-f00d-482f-825c-0abfcee8ccff
        window.fetch(Config.baseUrl + `Statistic/api/dynamicapi/${apiID}/GetData?Belegnr=${belegnr}`);
        this.props.api.reloadStatistic();
    }

    handleGiveCommercialApproval = (belegnr: string, apiID: string) => { //11d63e15-f37f-4e1c-8ac4-3d168ce20d2f
        window.fetch(Config.baseUrl + `Statistic/api/dynamicapi/${apiID}/GetData?Belegnr=${belegnr}`);
        this.props.api.reloadStatistic();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{ activeIndex: number; docGuid?: string; }>, snapshot?: any): void {
        if (this.props.data != prevProps.data) {
            this.setState({ activeIndex: 0 })
        }
    }


    render() {
        const cssProps: React.CSSProperties = { display: "inline-flex" };
        const filteredData = this.props.data?.filter((e, i) => i >= this.state.activeIndex * 10 && i < (this.state.activeIndex + 1) * 10);
        return <>
            <style>{css}</style>
            <div style={{ height: "100%", display: "flex" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className="material-card-rep-user-list" style={{ flex: "1" }}>
                        {this.props.data && this.props.data.length == 0 ? <NoEntries></NoEntries> : null}
                        <div className="material-card-rep-container-user">
                            {filteredData.map((r) => <Row
                                INNOSOFTUSER={r.INNOSOFTUSER ? r.INNOSOFTUSER : ""}
                                ISGUID={r.ISGUID ? r.ISGUID : ""}
                                OBSERVEDOBJECTGUID={r.OBSERVEDOBJECTGUID ? r.OBSERVEDOBJECTGUID : ""}
                                OBSERVEDOBJECTTYPE={r.OBSERVEDOBJECTTYPE ? r.OBSERVEDOBJECTTYPE : ""}
                                isSelected={this.state.ISGUID ? this.state.ISGUID == r.ISGUID : false}
                                onclick={(ISGUID) => { this.setState({ ISGUID: ISGUID, ticket: r.PROBLEMNR }) }}
                                ENTRY_DOC_ISGUID={r.ENTRY_DOC_ISGUID ? r.ENTRY_DOC_ISGUID : ""}
                                ENTRY_LINK={r.ENTRY_LINK ? r.ENTRY_LINK : ""}
                                VERANTWORTLICHER={r.VERANTWORTLICHER ? r.VERANTWORTLICHER : ""}
                                PROBLEMNR={r.PROBLEMNR ? r.PROBLEMNR : 0}
                                KOMMENTAR={r.KOMMENTAR ? r.KOMMENTAR : ""}
                                ADRNAME={r.ADRNAME ? r.ADRNAME : ""}
                                TICKETTYP={r.TICKETTYP ? r.TICKETTYP : ""}
                                TICKETSTATUS={r.TICKETSTATUS ? r.TICKETSTATUS : ""}
                                ENDZEIT={r.ENDZEIT ? r.ENDZEIT : ""}
                                reloadStatistics={() => { this.props.api.reloadStatistic() }}
                            ></Row>)}
                        </div>
                    </div>
                    <Pager data={this.props.data} activeIndex={this.state.activeIndex} onPageChanged={this.handlePageChanged} />
                </div>
                {
                    this.state.ticket ?
                        <EmbedTicketText key={this.state.ticket} ticket={this.state.ticket}></EmbedTicketText> :
                        <NoEntriesVorschau></NoEntriesVorschau>
                }
            </div>
        </>
    }

}
class Pager extends React.Component<{ activeIndex: number, onPageChanged, data: any[] }, any>{
    private pagerDiv: HTMLDivElement;
    private kendoPager;

    handlePageClick = (pageIndex: number) => {
        this.props.onPageChanged(pageIndex);
    }

    componentDidMount(): void {
        const dataSource = new kendo.data.DataSource({
            data: this.props.data,
            pageSize: 10,
        });


        const that = this;
        this.kendoPager = $(this.pagerDiv).kendoPager({
            dataSource: dataSource,
            change: function () {
                that.props.onPageChanged(this.page() - 1);
            }
        }).data("kendoPager");
        const p = this.kendoPager.setDataSource(dataSource);

    }
    componentWillUnmount(): void {
        this.kendoPager.destroy();
    }

    componentDidUpdate(prevProps: Readonly<{ activeIndex: number; onPageChanged: any; data: any[]; }>, prevState: Readonly<any>, snapshot?: any): void {
        if (this.props.data !== prevProps.data) {
            const dataSource = new kendo.data.DataSource({
                data: this.props.data,
                pageSize: 10
            });
            const p = this.kendoPager.setDataSource(dataSource);
        }
    }

    renderPager = () => {
        const aa: any[] = [];
        for (let i = 0; i <= (this.props.data.length / 10); i++) {
            aa.push(<a onClick={() => this.handlePageClick(i)} className={i == this.props.activeIndex ? "active" : ""} style={{ color: "black" }}>{i + 1}</a>)
        }
        return aa;
    }

    render() {
        return <div style={{ position: "sticky", bottom: "0px" }} ref={(e) => this.pagerDiv = e}></div>
    }
}

const css = `
 
    .pagination {
        display: grid;
        grid-template-columns: auto 1fr;
        background-color: white;
        justify-content: flex-start;
        height: 40px;
    }

     .pagination > div {
        text-align: center;
        padding: 20px 0;
        font-size: 30px;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
    }

    .pagination a.active {
        background-color: #303F9F;
        color: #303F9F;
    }

    .pagination a:hover:not(.active) {background-color: #ddd; color: #303F9F}

    .grid-item1, .grid-item4, .grid-item5, .grid-item7, .grid-item6, .grid-item10 {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .grid-item2, .grid-item3, .grid-item8, .grid-item9 {
        display: flex;
        align-items: center;
    }

    .grid-item11, .grid-item12 {
        display: none;
    }

    .material-card-rep-user{
        border: none;
        display: grid;
        background-color: #f5f5f5;

        grid-template-areas: 
        'ButtonOpen Verantwortlich Kommentar Tickettyp Termin Entfolgen '
        'ButtonOpen Ticketnummer Adressname Ticketstatus Termin Entfolgen ' ;

        grid-template-columns: 60px 150px 150px 120px 100px 60px;
        grid-template-rows: 34px 34px;
        column-gap: 3px;
    }

    .user_ticket_vorschau {
        display: flex;
        flex: 1 1 0%;
        justifyContent: center;
    }

    .user_ticket_vorschau_frame {
        flex: 1 1 0%;
        height: 100%;
        width: 100%;
        display: block;
    }

    .user_report_vorschau {
        display: flex;
        flex: 1 1 0%;
        justify-content: center;
    }

    .user_report_vorschau_iframe {
        flex: 1 1 0%; 
        height: 100%;
        width: 100%;
        display: block;
    }

    @media only screen and (max-width: 480px) {

        .user_report_vorschau, .user_report_vorschau_iframe, .user_ticket_vorschau_frame, .user_ticket_vorschau {
            display:none;
        }
       
        .material-card-rep-user{
            grid-template-areas: 
            'ButtonOpen Verantwortlich Entfolgen'
            'ButtonOpen Ticketnummer Entfolgen' ;

            grid-template-columns: 60px 140px auto;
            grid-template-rows: auto;
        }

        .grid-item1, .grid-item2, .grid-item7, .grid-item8{
            display:flex;
        }

        .grid-item11, .grid-item12{
            display: flex;
            align-items: center;
        }

        .grid-item3, .grid-item4, .grid-item5, .grid-item6, .grid-item9, .grid-item10 {
            display: none;
        }
    }

    .icon-t_freigabe {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        width: 35px;
    }

    .icon-t_freigabe:hover {
        color: #303F9F;
        animation-name: buttonhover-fade;
        animation-duration: .3s;
    }

    @keyframes buttonhover-fade {
        from {
            color: black;
        }
 
        to {
            color: #303F9F;
        }
    }

    .icon-t_freigabe-erteilt {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        width: 35px;
        border: 1px solid transparent;
        color: #4CAF50;
        transition: color 0.3s ease; 
    }

    .material-card-rep-user material-card-rep-user-clickable > div{
        text-align: center;
        padding: 20px 0; 
        font-size: 30px;
    }

    .material-card-rep-user-list{
        font-family: Open Sans;
        line-height: 1.4;
        height: 100%;
        overflow: auto;
    }


    .material-header-title{
        display: grid;
        grid-template-columns: auto auto auto 1fr;
        background-color: white;
        justify-content: flex-start;
        height: 55px;
    }

    .material-header-title > div {
        text-align: center;
        padding: 20px 0;
        font-size: 30px;
    }
    
    .material-card-rep-container-user{
        overflow: auto;
    }

   .external-Reports-user {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        width: 50px;
        border: 1px solid transparent;
        transition: border-color 0.3s ease; 
    }

    .buttonIcon {
        transition: all .3s ease-in-out;
    }

    .buttonIcon:hover {
        cursor: pointer;
        transform: scale(1.3);
        color: #00796B;
    }

    .material-card-rep-user material-card-rep-user-clickable{
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #cccccc",
        transition: "background-color 0.3s ease",
    }

    .material-card-rep-user material-card-rep-user-clickable:hover{
        background-color: #e3e3e3;
    }

    .material-div-link {
        position:absolute;
        width:100%;
        height:100%;
        top:0;
        left: 0;
        z-index: 1;
    }
}
`